import { createStore, select, withProps } from '@ngneat/elf';
import { Toast } from '@tmx/modus-operandi';
import { filter } from 'rxjs';

interface ToastsProps {
  toast: Partial<Toast> | null;
}

const toastsStore = createStore(
  { name: 'toasts' },
  withProps<ToastsProps>({
    toast: null,
  })
);

export const toast$ = toastsStore.pipe(
  select(({ toast }) => toast),
  filter((toast): toast is Partial<Toast> => toast !== null)
);

export function updateToast(toast: Partial<Toast>) {
  toastsStore.update((state) => ({
    ...state,
    toast,
  }));
}
